import { OrganizerUpsertPayload } from '../interfaces/organizer-upsert-payload';
import { UpsertOrganizerInput } from '../interfaces/upsert-organizer-input';

export function mapPayloadToUpsertInput(data: OrganizerUpsertPayload, adminUserId: number): UpsertOrganizerInput {
  const { logo, timezone: _timezone, ...rest } = data;
  return {
    ...rest,
    adminUserId,
    sportType: data.sportType.toString().toUpperCase(),
    logo: logo?.[0]?.img instanceof File ? logo[0].img : undefined,
  };
}
